<mat-toolbar color="accent" class="mat-elevation-z3">
  <mat-toolbar-row>
    <div class="w-100 row-container">
      <div class="row-container left">
        <button
          *ngIf="toolbar === NavigationToolbar.BRAND"
          mat-icon-button
          class="text-white"
          [routerLink]="backUrl"
          aria-label="atrás"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <button
          mat-icon-button
          class="text-white"
          (click)="toggleMenu.emit()"
          aria-label="menú"
        >
          <mat-icon>menu</mat-icon>
        </button>
        <lib-vakers-shell-ui-toolbar-logo
          *ngIf="toolbar !== NavigationToolbar.BRAND"
          [isVakiSite]="isVakiSite"
          [logo]="logo"
          [siteLogo]="siteLogo"
          [siteId]="siteId"
        >
        </lib-vakers-shell-ui-toolbar-logo>
      </div>
      <lib-vakers-shell-ui-toolbar-logo
        *ngIf="toolbar === NavigationToolbar.BRAND"
        [isVakiSite]="isVakiSite"
        [logo]="logo"
        [siteLogo]="siteLogo"
        [siteId]="siteId"
      >
      </lib-vakers-shell-ui-toolbar-logo>
      <lib-vakers-shell-ui-user-menu
        *ngIf="toolbar === NavigationToolbar.BRAND"
        [user]="user"
        [userLoggedIn]="userLoggedIn"
        (logout)="logout.emit()"
      >
      </lib-vakers-shell-ui-user-menu>
      <nav *ngIf="toolbar === NavigationToolbar.MAIN" class="row-container">
        <button
          *ngIf="!isVakiSite"
          mat-mini-fab
          color="primary"
          class="mx-2"
          (click)="showSubToolbar = !showSubToolbar"
          aria-label="Buscar"
        >
          <mat-icon class="text-white">search</mat-icon>
        </button>
        <button
          mat-raised-button
          color="primary"
          class="mx-2 hide-on--xs text-white"
          routerLink="/crear"
          aria-label="crea tu vaki"
          vakiCtrlRouterLink
          i18n
        >
          CREA TU VAKI
        </button>
        <button
          *ngIf="!isVakiSite"
          mat-mini-fab
          color="primary"
          class="mx-2 show-on--xs"
          routerLink="/crear"
          aria-label="Crear Vaki"
        >
          <mat-icon class="text-white">add</mat-icon>
        </button>

        <lib-vakers-shell-ui-user-menu
          [user]="user"
          [userLoggedIn]="userLoggedIn"
          [currentLanguage]="currentLanguage"
          [languages]="languages"
          [currentCurrency]="currentCurrency"
          [currencies]="currencies"
          (languageSelected)="languageSelected.emit($event)"
          (logout)="logout.emit()"
        >
        </lib-vakers-shell-ui-user-menu>
      </nav>
      <div *ngIf="toolbar === NavigationToolbar.VAKIS" class="row-container">
        <div
          *ngIf="
            isOwner && (isOpen || vakiAnalytics?.state === VakiState.BORRADOR)
          "
          class="mx-4 mt-2 align-center hide-on--xs column-container column-container"
        >
          <mat-slide-toggle
            color="primary"
            [checked]="editMode"
            (toggleChange)="changeEditMode()"
          ></mat-slide-toggle>
          <span class="mat-caption text-white mt-3">Modo edición</span>
        </div>

        <div *ngIf="isOpen" class="hide-on--xs">
          <a
            (click)="support()"
            class="txt-uppercase text-white"
            color="primary"
            mat-raised-button
            i18n="vaki-support-form |Support button @@vakiSupportButton"
            [routerLink]="getSupportUrl()"
            vakiCtrlRouterLink
          >
            <ng-container [ngSwitch]="vaki?.category?.brand ?? ''">
              <ng-container *ngSwitchCase="BRANDS_IDS.STARTER">
                PRE-COMPRAR
              </ng-container>
              <ng-container *ngSwitchCase="BRANDS_IDS.SPONSOR">
                PATROCINAR
              </ng-container>
              <ng-container *ngSwitchDefault
                ><span class="text-white"> APORTAR</span>
              </ng-container>
            </ng-container>
          </a>
        </div>
        <div class="hide-on-xs mx-4">
          <button
            mat-mini-fab
            aria-label="Share button with a share icon"
            [matMenuTriggerFor]="share"
            color="primary"
            class="mat-elevation-z0 border-primary"
          >
            <mat-icon class="text-white">share</mat-icon>
          </button>
          <mat-menu #share="matMenu" class="share-mat-menu" xPosition="before">
            <div class="w-100 p-2">
              <lib-vakers-vakis-ui-share-box
                [vaki]="vaki"
                [analytics]="vakiAnalytics"
                [utmMedium]="'toolbar'"
                [currentLanguage]="currentLanguage"
              ></lib-vakers-vakis-ui-share-box>
            </div>
          </mat-menu>
        </div>
        <div *ngIf="cartTotalRewards">
          <button
            mat-mini-fab
            color="primary"
            (click)="openCart()"
            aria-label="Carrito"
          >
            <mat-icon
              [matBadge]="cartTotalRewards"
              matBadgeColor="warn"
              class="text-white"
            >
              shopping_cart
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-toolbar *ngIf="showSubToolbar" class="search-toolbar mat-elevation-z3">
  <div class="w-100 container column-container">
    <mat-form-field appearance="outline" floatLabel="auto" class="w-100">
      <mat-label i18n="explore header | Search input label @@searchInputLabel">
        Buscar en las Vakis
      </mat-label>
      <mat-icon matPrefix class="mr-3">search</mat-icon>
      <input
        matInput
        i18n-placeholder="
          explore | Input enter your keyword @@inputEnterKeyword"
        [formControl]="searchTerm"
      />
      <button
        mat-icon-button
        matSuffix
        [attr.aria-label]="'Borrar Filtro'"
        [attr.aria-pressed]="'Borrar'"
        (click)="resetInput()"
        aria-label="cerrar"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <button
      mat-mini-fab
      color="accent"
      (click)="showSubToolbar = false"
      aria-label="Cerrar"
    >
      <mat-icon color="primary">close</mat-icon>
    </button>
  </div>
</mat-toolbar>
